// extracted by mini-css-extract-plugin
module.exports = {"emailForm":"EmailForm_emailForm__42px3","emailInput":"EmailForm_emailInput__LIWVu","feedback":"EmailForm_feedback__7tZyH","submitButton":"EmailForm_submitButton__0s4ag"};